/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */

/**
 * @nullable
 */
export type CreateIncomingPurchaseDocumentBodyTransactionType = typeof CreateIncomingPurchaseDocumentBodyTransactionType[keyof typeof CreateIncomingPurchaseDocumentBodyTransactionType] | null;


export const CreateIncomingPurchaseDocumentBodyTransactionType = {
  domestic: 'domestic',
  intra_eu_b2b: 'intra_eu_b2b',
  intra_eu_b2c: 'intra_eu_b2c',
  '3w_b2b': '3w_b2b',
  '3w_b2c': '3w_b2c',
  export: 'export',
} as const;
